<template>
  <div class="content_list">
    <div
      class="list_item"
      v-for="(item, index) in companyLists"
      :key="index"
      @click="toDetails(item)"
    >
      <div class="image_box">
        <el-image class="item_img" :src="item.logo" fit="contain"></el-image>
      </div>
      <div class="m_div">
        <div class="item_text1">
          {{ langSet == "cn" ? item.companyName : item.enCompanyName }}
        </div>
        <!-- <div class="item_text" v-if="item.boothNo">
          {{ langSet == 'cn' ? '展位号：' : 'Booth no：' }}{{ item.boothNo }}
        </div> -->
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "company_list",
  components: {},
  props: ["companyLists", "external"],
  data() {
    return {
      langSet: "",
    };
  },
  created() {},
  mounted() {
    this.langSet = this.$language;
  },
  methods: {
    //25.9.17 跳转详情 dxm
    toDetails(e) {
      this.$router.push({
        path: "/companyDetails",
        query: {
          id: e.exhibitor_long_id,
        },
      });
    },
  },
};
</script>


<style scoped lang="scss">
.content_list {
  display: flex;
  flex-wrap: wrap;
}
.list_item {
  padding: 15px;
  width: calc(100% / 5 - 16px);
  height: 220px;
  font-weight: 500;
  font-size: 16px;
  color: #2c2c2e;
  line-height: 22px;
  background: #f7f8fa;
  box-sizing: border-box;
  text-align: left;
  margin-right: 20px;
  margin-bottom: 20px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.5s ease-in-out;
  &:hover {
    background: #e9eaf2;
    border-radius: 15px;
  }
  &:nth-child(5n) {
    margin-right: 0;
  }
  .image_box {
    //width: 275px;
    height: 130px;
    background: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 15px;
    .item_img {
      width: 100%;
      height: 100%;
    }
  }
  .item_text1 {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .item_text{
    color: #666;
    font-size: 12px;
    margin-top: 5px;
  }
}

.margin_bottom {
  width: 100%;
  margin-bottom: 8px;
}

.item_text2 {
  font-weight: 400;
  font-size: 18px;
  color: #757575;
  line-height: 25px;
  text-align: left;
  font-style: normal;
}

.item_text3 {
  font-weight: 400;
  font-size: 18px;
  color: #757575;
  line-height: 25px;
  text-align: left;
  font-style: normal;
}
@media only screen and (max-width: 767px) {
  .content_list {
    margin: 0;
    .list_item {
      width: 3.17rem;
      height: 3.5rem;
      flex: inherit;
      padding: 0.19rem;
      margin: 0 0.38rem 0.29rem 0;
      &:nth-child(2n) {
        margin-right: 0;
      }
      .image_box {
        width: 100%;
        height: 1.69rem;
        padding: 0;
        margin-bottom: 0.19rem;
      }
      .m_div {
        flex: 1;
        .item_text1 {
          font-size: 0.29rem;
          line-height: 0.4rem;
          white-space: inherit;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2; /* 限制文本显示为3行，超出部分显示省略号 */
          overflow: hidden;
        }
        .item_text2,
        .item_text3 {
          color: #757575;
          font-size: 0.25rem;
          line-height: 0.35rem;
        }
        .margin_bottom {
          width: 84%;
          margin-bottom: 0.1rem;
        }
        .item_text3 {
          margin-bottom: 0;
        }
      }
    }
  }
}
</style>